export const manage = {
  manageFlowPara: 'Edytuj i zmieniaj dane wybranego szablonu konfiguracji',
  version: 'Wersja',
  name: 'Nazwa',
  code: 'Kod',
  createdBy: 'Autor',
  modelUnitConversion: 'Przelicznik jednostek modelu',
  dimensionModeEnabledInfo:
    'Przełącznik włączony: długości są domyślne. Pole przelicznika jednostek modelu jest wtedy nieaktywne.',
  dimensionModeDisabledInfo:
    'Przełącznik wyłączony: możesz ręcznie zdefiniować przelicznik jednostek modelu, który wpływa na długość sceny i wyliczenia.',
  dimensionModeEditInfo:
    'Modyfikacja jednostki długości sceny i przelicznika jest możliwa tylko dla szkicu (draft) i przy uprawnieniu EDIT.',
  criteriaSummaryDescription: 'Sprawdź wybrane kryteria i zatwierdź zmiany.',
  savedSuccess: 'Zapisano zmiany',
  criterionIssue: {
    deleted: 'Kryterium zostało usunięte i nie może być dłużej używane',
    inactive:
      'Ta opcja jest nieaktywna, szablon można zapisać, ale nie opublikować',
  },
}
